// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","page":"product-page-pl-renderer_page__bAj0r"};